/*
 * ConferenceCallInformationForm Messages
 *
 * This contains all the text for the ConferenceCallInformationForm component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  conferenceCallInformation: {
    id: 'CONFERENCE_VIEW_INFORMATION.conference_VIEW_information',
    defaultMessage: 'General information',
  },
  transcriptTitle: {
    id: 'CONFERENCE_VIEW_INFORMATION.transcriptTitle',
    defaultMessage: 'Title',
  },
  conferenceDate: {
    id: 'CONFERENCE_VIEW_INFORMATION.conferenceDate',
    defaultMessage: 'Date',
  },
  people: {
    id: 'CONFERENCE_VIEW_INFORMATION.people',
    defaultMessage: 'Participants',
  },
  tags: {
    id: 'CONFERENCE_VIEW_INFORMATION.tags',
    defaultMessage: 'Tags',
  },
  createHumanTranscription: {
    id: 'CONFERENCE_VIEW_INFORMATION.createHumanTranscription',
    defaultMessage: 'Generate Human transcription',
  },
  createAITranscription: {
    id: 'CONFERENCE_VIEW_INFORMATION.createAITranscription',
    defaultMessage: 'Generate AI transcription',
  },
  useTwoFactorAuth: {
    id: 'CONFERENCE_VIEW_INFORMATION.useTwoFactorAuth',
    defaultMessage: 'use two-factor authentication for transcription',
  },
  allowAudioDownload: {
    id: 'CONFERENCE_VIEW_INFORMATION.allowAudioDownload',
    defaultMessage: 'Allow audio download',
  },
  introMessage: {
    id: 'CONFERENCE_VIEW_INFORMATION.introMessage',
    defaultMessage: 'Intro message',
  },
  clientReference: {
    id: 'CONFERENCE_VIEW_INFORMATION.clientReference',
    defaultMessage: 'Client reference',
  },
  client: {
    id: 'CONFERENCE_VIEW_INFORMATION.client',
    defaultMessage: 'Client',
  },
  organization: {
    id: 'CONFERENCE_VIEW_INFORMATION.organization',
    defaultMessage: 'Organization',
  },
});



// WEBPACK FOOTER //
// ./components/templates/ConferenceCallView/messages.js